import React, { memo, Fragment, useState, useEffect } from 'react'
import TextField from '@material-ui/core/TextField'
import classNames from 'classnames'
import Title from 'root/src/client/web/typography/Title'
import Button from 'root/src/client/web/base/Button'
import { ternary } from 'root/src/shared/util/ramdaPlus'
import clipHandler from 'root/src/client/logic/project/handlers/clipHandler'
import unescapeHtml from 'root/src/shared/util/unescapeHtml'

export default memo(({
	classes, canEditProjectDetails, projectTitle, projectDescription,
	updateProject, dareTitle, fontSize, isMobileRes, DareDetailIconSet, projectUrl,
}) => {
	const [title, setTitle] = useState(unescapeHtml(projectTitle))
	const [description, setDescription] = useState(unescapeHtml(projectDescription))

	useEffect(() => {
		setTitle(unescapeHtml(projectTitle))
		setDescription(unescapeHtml(projectDescription))
	}, [projectTitle, projectDescription])

	return (
		ternary(canEditProjectDetails,
			<Fragment>
				<TextField
					label="Title"
					type="text"
					value={title || ''}
					onChange={e => setTitle(e.target.value)}
					variant="outlined"
					fullWidth
					InputProps={{ style: { color: 'white' } }}
				/>
				<TextField
					multiline
					value={description || ''}
					onChange={e => setDescription(e.target.value)}
					variant="outlined"
					fullWidth
					rows="3"
					label="Description"
					className={classes.textFieldRoot}
					InputProps={{ style: { color: 'white' } }}
				/>
				<div style={{ height: 42 }}>
					<Button
						onClick={() => updateProject({ title, description, projectUrl })}
						isSmallButton
					>
						Save
					</Button>
				</div>
			</Fragment>,
			<Fragment>
				<div className="layout-row">
					<Title medium {...{ fontSize, dareTitle }}>{title}</Title>
					{isMobileRes && <DareDetailIconSet />}
				</div>
				<div
					title={description}
					className={classNames(
						!fontSize && 'flex',
						!fontSize && classes.description,
						fontSize && classes.completedDareDescription,
					)}
				>
					{clipHandler(description || '', 240)}
				</div>
			</Fragment>)
	)
})
